import { motion } from 'framer-motion';
import { css, styled } from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    recipesTextArea,
    styledInteraction,
    styledSkeleton,
} from '@pkg/primitives';

import { tokens as editIconTokens } from '../EditIcon/EditIcon.tokens';

import { baseTextStyles, baseWrapperStyles, textElementStyles, tokens } from './UserBio.tokens';

export const StyledUserBio = styled.div`
    position: relative;
    display: grid;
    justify-items: start;
    max-width: calc(100% - ${editIconTokens.size + editIconTokens.offset}px);
`;

export const TextAreaWrapper = styled.div`
    ${baseWrapperStyles};
    position: relative;
    margin-top: ${tokens.padding.top * -1}px;
    margin-bottom: ${tokens.padding.rest * -1}px;
    margin-left: ${tokens.padding.rest * -1}px;
    margin-right: ${tokens.padding.rest * -1}px;

    @media (min-width: 768px) {
        display: grid;
    }

    textarea {
        ${baseTextStyles};
        ${recipesTextArea.basic};

        cursor: pointer;
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        color: rgb(255, 255, 255, 0.6);
        background-color: rgb(255, 255, 255, 0);
        border-radius: ${tokens.radius}px;

        &::placeholder {
            color: currentColor;
            opacity: 0.6;
        }

        &:hover,
        &:focus {
            color: rgb(255, 255, 255, 1);
        }

        &:focus {
            background-color: rgb(255, 255, 255, 0.06);
        }

        &:focus,
        &:disabled,
        &:read-only {
            cursor: unset;
        }

        &:disabled,
        &:read-only {
            background-color: transparent;
        }

        &[data-input-error]:focus-visible {
            outline-color: ${designColor.red};
        }
    }
`;

export const MirrorText = styled.span`
    ${textElementStyles};
    ${styledInteraction.interactionDisable};
    position: relative;
    z-index: 1;
    display: block;
    padding-top: ${tokens.padding.top}px;
    padding-bottom: ${tokens.padding.rest}px;
    padding-left: ${tokens.padding.rest}px;
    padding-right: ${tokens.padding.rest}px;
    color: transparent;
    opacity: 0;
`;

interface StaticLabelProps {
    $loading?: boolean;
}

export const StaticLabel = styled.p<StaticLabelProps>`
    ${baseWrapperStyles};
    ${textElementStyles};
    padding: 0;
    color: rgb(255, 255, 255, 0.6);
    transition: opacity ${duration.normal}ms ${easing.cubic};

    ${({ $loading }) =>
        $loading &&
        css`
            opacity: 0;
        `};
`;

export const Skeleton = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    position: absolute;
    inset: 0;
`;

export const SkeletonLabel = styled.div`
    ${styledSkeleton.baseStyles};
    width: 100%;
    height: 100%;
    border-radius: ${tokens.radius}px;
`;
